<template>
  <div class="zgeMapBox">
    <div class="map-dz"></div>
    <div class="map-bg"></div>
    <video data-v-0556c46b="" x5-video-player-type="h5" playsinline="" webkitplaysinline="true" muted="muted"
        autoplay="autoplay" loop="loop" src="@/assets/mapImg_Center/map-ani.webm" poster="" x5-playsinline=""
        webkit-playsinline="" controlslist="nodownload" class="map-ani"></video>
    <div class="mapBox" :style="mapBoxStyle">
      <!-- <div class="c1-title">
        <img src="@/assets/mapImg_Center/map-title.png" alt="" class="map-title-img" />
        <p>{{ mapName }}{{ cativeText }}</p>
      </div> -->
      <div>
        <img v-for="(v, index) in mapImg1" :key="index + v.city_name" :src="getImg(v.img, city_location)" alt=""
          class="mapimg" v-show="v.city_show" />
      </div>
      <div v-if="!city_show">
        <div class="title_active" v-for="(v, index) in mapImg1" :key="index + v.img" v-show="v.textShow"
          :style="{ top: +v.text_top + 'px', left: +v.text_left + 'px' }">
          {{ v.new_city_name || v.city_name }}
        </div>
      </div>
      <div v-if="city_show">
        <div class="title_active" v-for="(v, index) in mapImg1" :key="index + v.img" v-show="v.textShow"
          @mouseover="mouseoverText(v.city_name, index, $event)" @mouseout="mouseoutText(index)"
          :style="{ top: +v.text_top + 'px', left: +v.text_left + 'px' }">
          {{ v.new_city_name || v.city_name }}
        </div>
      </div>

      <div class="active" :style="{ top: top, left: left }">
        <span>
          {{ cativeText }}
        </span>
      </div>

      <div class="textBox" :style="tooltipStyle">
        <div class="title">
          {{ cativeText }}
        </div>
        <div class="textList" v-if="mapImg1 && mapImg1[textListIndex]">
          <div class="textList_li" v-for="(v, index) in mapImg1[textListIndex].text_List || []" :key="index"
            @mouseover="pauseAutoTime" @mouseout="resumeAutoTime">
            <img src="@/assets/mapImg_Center/l1-icon.png" alt="" />
            <div class="name" :title="v.dataName">{{ v.dataName }}</div>
            <span class="colorText" :title="v.label">{{ v.label }}</span>
          </div>
        </div>
      </div>

      <div class="SpecialMap" v-if="Show_SpecialMap">
        <div class="SpecialMap_city" v-for="(v, index) in mapImg1" :key="index + v.img"
          @mouseover="mouseoverText(v.city_name, index, $event)" @mouseout="mouseoutText(index)">
          <div v-show="v.new_city_name" class="SpecialMap_name">
            {{ v.new_city_name }}&nbsp;:&nbsp;&nbsp;{{ v.city_name }}
          </div>
        </div>
      </div>
    </div>

    <div class="componentS" v-show="showCitySelect">
      <!--  控制城市选择组件的显示 -->
      <div class="componentTitle">
        <div class="componentTitleName">地图切换</div>
        <div class="componentclose" @click="cancelCity">
          <img src="../../assets/close.png" style="width: 100%" />
        </div>
      </div>
      <!-- 头部和组件文字编辑 -->
      <div class="componentContents">
        <!-- <div class="single">
          <div class="r_input">
            <el-select v-model="selectedCity" placeholder="请选择">
              <el-option v-for="item in cityList" :key="item" :label="item" :value="item">
                <span style="float: left">{{ item }}</span>
              </el-option>
            </el-select>
          </div>
        </div> -->
        <div class="pre" @click="compre"></div>
        <div class="next" @click="comnext"></div>
        <div class="componentClassAll" ref="comps">
          <div :class="{ componentClassMenu: true, active: item.name == sortactive }" v-for="(item, i) in cityNew"
            :key="i" @click="menuclick(item)">{{ item.name }}</div>
        </div>
        <div class="componentListAll">
          <div v-for="(item, index) in 8"
            :class="{ 'active': seclist[index + (currentPage - 1) * 8].bg == imgbg, componentList: true }" :key="index"
            v-if="seclist.length && seclist[index + (currentPage - 1) * 8]" @click="setMap(index)">
            <div class="componentPic">
              <img :src="getImgBg(seclist[index + (currentPage - 1) * 8].bg, seclist[index + (currentPage - 1) * 8].city)" :onerror="defaultImg" />
            </div>
            <div class="componentPicName">【地图】{{ seclist[index + (currentPage - 1) * 8].name }}</div>
          </div>
          <div class="nodata" v-if="!seclist.length">
            <img src="@/assets/nodata.png" alt="" class="nodata-img" />
          </div>
          <div class="page_bottom">
            <el-pagination background layout="prev, pager, next" :total="seclist.length" :page-size="8"
              @current-change="componentPageChange" :current-page="currentPage" :small="true">
            </el-pagination>
          </div>
        </div>
        <div class="single_btn">
          <el-button @click="confirmCity" type="primary" v-if="showCitySelect">确认</el-button>
          <el-button @click="cancelCity">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ChinaMap from "./ChinaMap.json";

export default {
  name: "template.scope1.center4",
  props: {
    vdata: {
      type: [Array, String],
      default: () => [],
    },
    jsondata: {
      type: [Array, String],
      default: () => [],
    },
    scopedata: {
      type: Object,
      default: () => { },
    },
    cityId: {
      type: String,
      default: "beijing",
    },
  },
  data() {
    return {
      title: "地图-scope_China",
      defaultImg: 'this.src = "' + require("../../assets/imgerror.png") + '"', //默认图片的地址
      timer: null, // 定时器
      defaultdata: [
        { value1: "数据一", value2: "怀柔区", value3: "重点" },
        { value1: "数据二", value2: "怀柔区", value3: "" },
        { value1: "数据三", value2: "海淀区", value3: "" },
        { value1: "数据四", value2: "怀柔区", value3: "特殊" },
        { value1: "数据五", value2: "延庆区", value3: "" },
        { value1: "数据七", value2: "延庆区", value3: "" },
        { value1: "数据七", value2: "昌平区", value3: "" },
        { value1: "数据七", value2: "门头沟区", value3: "" },
        { value1: "数据一", value2: "延庆区", value3: "重点" },
        { value1: "数据二", value2: "顺义区", value3: "重点" },
        { value1: "数据三", value2: "朝阳区", value3: "重点" },
      ], // 表格数据
      valueMap: [
        { name: "数据", key: "value1" },
        { name: "地区", key: "value2" },
        { name: "标注", key: "value3" },
      ],
      exceldata: [], // 表格数据
      apiconfig: {}, // 接口数据
      isApi: false, // 是否是api数据
      scope: {}, // 作用域数据
      config: {}, // 配置数据
      top: "", //默认显示什么地区的top，会被重新赋值进行高亮提示
      left: "", //默认显示什么地区的lfet，会被重新赋值进行高亮提示
      imgbg: "", // 显示背景图片
      cativeText: "", //默认显示什么地区的城市，会被重新赋值进行高亮提示
      mapName: "", //地图名称
      textListIndex: 0, // 存储当前鼠标悬停的文本列表索引
      mapImg1: [], // 地图图片数据
      localcity_data: null, // 存储本地城市数据
      autoTimePaused: false, // 新增变量，用于标记定时器是否暂停
      tooltip_bottom: "-2%", //默认显示窗口数据的定位bottom
      tooltip_right: "10%", //默认显示窗口数据的定位right
      city_location: "beijing", //控制地图显示的地区 默认北京
      city_show: true, //  false true 控制地图显示的地区
      showCitySelect: false, // 控制城市选择组件的显示
      selectedCity: "", // 存储所选城市的名称
      cityList: [
        "北京",
        "福建",
        "广东",
        "湖北",
        "湖南",
        "江西",
        "辽宁",
        // "内蒙古",
        // "宁夏",
        // "青海",
        // "山东",
        // "山西",
        // "四川",
        // "台湾",
        // "新疆",
        // "西藏",
        "上海",
        "安徽",
        "甘肃",
        "广西",
        "浙江",
        "贵州",
        "河南",
        "天津",
        "海南",
        "江苏",
        "河北",
        "黑龙江",
        // "重庆",        // 补充直辖市
        // "香港",        // 补充特别行政区
        // "澳门",
        // "云南",        // 补充省份
        // "陕西",
        "吉林",
        "阳谷县",
      ], // 城市列表
      cityNew: [
        {
          name: '全部',
          childs: []
        },
        {
          name: '北京市',
          childs: [{ name: '北京', city: 'beijing', bg: 'beijing_zgeMap.png' }]
        }, {
          name: '福建省',
          childs: [{ name: '福建', city: 'fujian', bg: 'fujian_zgeMap.png' }]
        }, {
          name: '上海市',
          childs: [{ name: '上海', city: 'shanghai', bg: 'shanghai_zgeMap.png' }]
        }, {
          name: '广东省',
          childs: [{ name: '广东', city: 'fujian', bg: 'guangdong_zgeMap.png' }]
        }, {
          name: '湖北省',
          childs: [{ name: '湖北', city: 'hubei', bg: 'hubei_map.png' }]
        }, {
          name: '湖南省',
          childs: [{ name: '湖南', city: 'hunan', bg: 'hunan_map.png' }]
        }, {
          name: '江西省',
          childs: [{ name: '江西', city: 'jiangxi', bg: 'jiangxi_map.png' }]
        }, {
          name: '辽宁省',
          childs: [{ name: '辽宁', city: 'liaoning', bg: 'liaoning_map.png' }]
        }, {
          name: '安徽省',
          childs: [{ name: '安徽', city: 'anhui', bg: 'anhui_zgeMap.png' }]
        }, {
          name: '甘肃省',
          childs: [{ name: '甘肃', city: 'gansu', bg: 'gansu_zgeMap.png' }]
        }, {
          name: '广西省',
          childs: [{ name: '广西', city: 'guangxi', bg: 'guangxi_zgeMap.png' }]
        }, {
          name: '浙江省',
          childs: [{ name: '浙江', city: 'zhejiang', bg: 'zhejiang_zgeMap.png' }]
        }, {
          name: '贵州省',
          childs: [{ name: '贵州', city: 'guizhou', bg: 'guizhou_zgeMap.png' }]
        }, {
          name: '河南省',
          childs: [{ name: '河南', city: 'henan', bg: 'henan_zgeMap.png' }]
        }, {
          name: '天津省',
          childs: [{ name: '天津', city: 'tianjin', bg: 'tianjin_zgeMap.png' }]
        }, {
          name: '海南省',
          childs: [{ name: '海南', city: 'hainan', bg: 'hainan_map.png' }]
        }, {
          name: '江苏省',
          childs: [{ name: '江苏', city: 'jiangsu', bg: 'jiangsu_zgeMap.png' }]
        }, {
          name: '河北省',
          childs: [{ name: '河北', city: 'hebei', bg: 'hebei_zgeMap.png' }]
        }, {
          name: '黑龙江省',
          childs: [{ name: '黑龙江', city: 'heilongjiang', bg: 'heilongjiang_zgeMap.png' }]
        }, {
          name: '吉林省',
          childs: [{ name: '吉林', city: 'jilin', bg: 'jilin_map.png' }]
        }, {
          name: '山东省',
          childs: [{ name: '阳谷', city: 'yanggu', bg: 'yanggu_zgeMap.png' }]
        }
      ],
      sortactive: '全部',
      cityPinyinMap: {
        北京: "beijing",
        福建: "fujian",
        湖北: "hubei",
        广东: "guangdong",
        上海: "shanghai",
        安徽: "anhui",
        甘肃: "gansu",
        广西: "guangxi",
        浙江: "zhejiang",
        贵州: "guizhou",
        河南: "henan",
        海南: "hainan",
        江苏: "jiangsu",
        天津: "tianjin",
        河北: "hebei",
        黑龙江: "heilongjiang",
        湖南: "hunan", // 补充
        江西: "jiangxi", // 补充
        辽宁: "liaoning", // 补充
        内蒙古: "neimenggu", // 补充
        吉林: "jilin",
        云南: "yunnan",
        陕西: "shanxi",
        重庆: "chongqing", // 补充
        香港: "xianggang", // 补充
        澳门: "aomeng ", // 补充
        宁夏: "ningxia", // 补充
        青海: "qinghai", // 补充
        山东: "shandong", // 补充
        山西: "shanxi", // 补充
        四川: "sichuan", // 补充
        台湾: "taiwan", // 补充
        新疆: "xinjiang", // 补充
        西藏: "xizang", // 补充
        阳谷县: "yanggu", // 补充
      }, // 城市拼音映射
      exclusionMap: ["tianjin", "chongqing"], // 特殊的城市,城市显示文字a,b,c,d,e...，需要开启小窗口显示文字
      Show_SpecialMap: false, // 特殊城市小窗口显示隐藏
      pageindex: 1,
      seclist: [],
      currentPage: 1,
      oldmap: '',
      secitem: {}
    };
  },
  computed: {
    mapBoxStyle() {
      return {
        background: `url('${this.getImgBg(
          this.imgbg,
          this.city_location
        )}') no-repeat center/100% 100%`,
      };
    },
    tooltipStyle() {
      return {
        bottom: this.tooltip_bottom,
        right: this.tooltip_right,
      };
    },
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        this.defaultdata = n;
        // this.addDataToTextList(); // 当 vdata 更新时，重新添加数据到 text_List
      }
    },
    jsondata(n) {
      this.exceldata = n;
    },
    defaultdata(n) {
      this.addDataToTextList(); // 当 vdata 更新时，重新添加数据到 text_List
    },
    //目前没有用到
    cityId(newVal, oldVal) {
      // console.log("cityId 发生了变化:", newVal, oldVal);
      this.city_location = newVal;
      // 可以在这里调用其他方法，例如重新加载数据
      this.addDataToTextList();
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    mouseoverText(name, index, e) {
      let dom = e.target;
      this.textListIndex = index;
      this.cativeText = name;
      clearTimeout(this.timer);
      this.timer = null;

      this.mapImg1.forEach((i) => {
        if (i.city_name == name) {
          i.textShow = false;
          i.city_show = true;
          this.cativeText = name;
          this.top = i.city_top + "px";
          this.left = i.city_left + "px";
          // this.top = parseInt(dom.style.top.match(/\d+/)[0]) - 50 + "px";
          // this.left = parseInt(dom.style.left.match(/\d+/)[0]) - 50 + "px";
          // console.log(this.top, this.left, "|mouseoverText|");
        } else {
          i.textShow = true;
          i.city_show = false;
        }
      });
    },
    mouseoutText(index) {
      this.autoTime(index + 1);
    },
    autoTime(index = 0) {
      let times = index;
      this.timer = setInterval(() => {
        if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
        if (times >= this.mapImg1.length) {
          times = 0;
        }
        this.textListIndex = times;
        this.mapImg1.forEach((item, index) => {
          if (index == times) {
            item.textShow = false;
            item.city_show = true;
            this.cativeText = item.city_name;
            this.top = item.city_top + "px";
            this.left = item.city_left + "px";
          } else {
            item.textShow = true;
            item.city_show = false;
          }
        });
        times++;
        if (times > this.mapImg1.length) {
          times = 0;
        }
      }, 10000);
    },
    getImgBg(url, city_location) {
      try {
        return require(`@/assets/mapImg_Center/${city_location}/${url}`);
      } catch (error) {
        return require("@/assets/mapImg_Center/beijing/beijing_zgeMap.png");
      }
    },
    getImg(url, city_location) {
      try {
        console.log();

        return require(`@/assets/mapImg_Center/${city_location}/${url}`);
      } catch (error) {
        const defaultProvince = this.localcity_data.defaultdata[0];
        const defaultCity = defaultProvince.child[this.textListIndex];
        return require(`@/assets/mapImg_Center/${defaultProvince.city_id}/${defaultCity.img}`);
      }
    },
    // fetchfujianData() {
    //   return new Promise((resolve) => {
    //     // 模拟异步操作
    //     setTimeout(() => {
    //       this.localcity_data = JSON.parse(JSON.stringify(ChinaMap));
    //       resolve(this.localcity_data);
    //     }, 1000);
    //   });
    // },
    addDataToTextList() {
      // 清空原有的 text_List 数据
      if (this.localcity_data) {
        // 检查 this.localcity_data 中是否有 this.city_location

        const locationData = this.localcity_data.defaultdata.findIndex(
          (item) => item.city_id == this.city_location
        );
        console.log('__isloca', locationData)
        if (locationData !== -1) {
          // 如果有，使用该数据
          const defaultLocation = this.localcity_data.defaultdata[locationData];
          defaultLocation.child.forEach((item) => {
            item.text_List = [];
          });

          //判断一下defaultLocation是否在exclusionMap里面，有的话做其他处理
          if (this.exclusionMap.includes(defaultLocation.city_id)) {
            // console.log(defaultLocation, "有我们要排除的地区");

            this.Show_SpecialMap = true;
          }
          // console.log(defaultLocation, "this.imgbg");

          this.defaultdata.forEach((datalist) => {
            const street = datalist.value2;
            const streetObj = defaultLocation.child.find(
              (item) => item.city_name == street
            );
            if (streetObj) {
              streetObj.text_List.push({
                dataName: datalist.value1,
                label: datalist.value3,
              });
            }
          });

          this.mapImg1 = [...defaultLocation.child];
          this.top = this.mapImg1[0].city_top + "px";
          this.left = this.mapImg1[0].city_left + "px";
          this.cativeText = this.mapImg1[0].city_name;
          this.imgbg = defaultLocation.img;
          this.mapName = defaultLocation.name;
          this.tooltip_bottom = defaultLocation.tooltip_bottom;
          this.tooltip_right = defaultLocation.tooltip_right;
          // console.log(defaultLocation, "this.imgbg");

          // console.log(
          //   this.mapImg1,
          //   this.tooltip_bottom,
          //   this.tooltip_right,
          //   "this.mapImg1|||_________"
          // );
        } else {
          // 如果没有，使用默认值（这里假设默认值是第一个地区的数据）
          const defaultLocation = this.localcity_data.defaultdata[0];
          defaultLocation.child.forEach((item) => {
            item.text_List = [];
          });

          this.defaultdata.forEach((datalist) => {
            const street = datalist.value2;
            const streetObj = defaultLocation.child.find(
              (item) => item.city_name === street
            );
            if (streetObj) {
              streetObj.text_List.push({
                dataName: datalist.value1,
                label: datalist.value3,
              });
            }
          });

          this.mapImg1 = [...defaultLocation.child];
          this.top = this.mapImg1[0].city_top + "px";
          this.left = this.mapImg1[0].city_left + "px";
          this.cativeText = this.mapImg1[0].city_name;
          this.imgbg = defaultLocation.img;
          this.mapName = defaultLocation.name;
          this.tooltip_bottom = defaultLocation.tooltip_bottom;
          this.tooltip_right = defaultLocation.tooltip_right;
          // console.log(defaultLocation);
          // console.log(this.mapImg1, "this.mapImg21|||_________");
        }
        // console.log(this.mapImg1);
      }
    },
    pauseAutoTime() {
      this.autoTimePaused = true; // 标记定时器暂停
    },
    resumeAutoTime() {
      this.autoTimePaused = false; // 标记定时器恢复
    },
    confirmCity() {
      // 当点击确认按钮时，执行的逻辑
      // console.log("确认按钮被点击");
      this.$confirm(
        "更换地图后数据将被重置为默认数据，是否保存当前地图?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          const pinyinName = this.secitem.city
          if (pinyinName) {
            this.scopedata.cityId = pinyinName;
            let selectcity = this.localcity_data.defaultdata.find(item => item.city_id == pinyinName)
            let selectlength = 3
            if (selectcity.child.length < 3) {
              selectlength = selectcity.child.length
            }
            let newdefault = []
            for (var i = 0; i < selectlength; i++) {
              let newitem = {
                value1: '数据一',
                value2: selectcity.child[i].city_name,
                value3: '填写示例'
              }
              newdefault.push(newitem)
            }
            this.defaultdata = newdefault
            this.scopedata.jsondata = ''
            this.scopedata.vdata = this.defaultdata
            // this.addDataToTextList(); // 更新数据
            //将数据上传服务器，字段1：city_location，字段2最新的this.defaultdata
            this.$emit("save", this.scopedata);
            this.showCitySelect = false; // 控制城市选择组件的显示;
          }
        })
        .catch(() => {
          this.imgbg = this.oldmap
          this.showCitySelect = false; // 控制城市选择组件的显示;
        });
    },
    cancelCity() {
      this.imgbg = this.oldmap
      this.showCitySelect = false; // 控制城市选择组件的显示;
    },
    menuclick(item) {
      if (item.name == this.sortactive) return
      this.sortactive = item.name
      this.setlist()
    },
    setlist() {
      if (this.sortactive == '全部') {
        this.seclist = []
        this.cityNew.forEach(arr => {
          this.seclist.push(...arr.childs)
        })
      } else {
        this.seclist = this.cityNew.find(item => item.name == this.sortactive).childs
      }
      console.log('___set', this.seclist)
    },
    compre() {
      const dom = this.$refs.comps
      const widths = dom.clientWidth
      let left = dom.scrollLeft
      if (left > 0) {
        left -= widths
        if (left < 0) {
          left = 0
        }
      }
      dom.scrollTo({
        left: left,
        behavior: 'smooth'
      })
    },
    comnext() {
      const dom = this.$refs.comps
      const widths = dom.clientWidth
      const widths2 = dom.scrollWidth
      let left = dom.scrollLeft
      if (left < widths) {
        left += widths
        if (left > widths2) {
          left = widths2
        }
      }
      dom.scrollTo({
        left: left,
        behavior: 'smooth'
      })
    },
    componentPageChange(currentPage) {
      this.currentPage = currentPage;
    },
    setMap(index) {
      this.imgbg = this.seclist[index + (this.currentPage - 1) * 8].bg
      this.secitem = this.seclist[index + (this.currentPage - 1) * 8]
    },
    openMapsec() {
      this.oldmap = JSON.parse(JSON.stringify(this.imgbg))
      this.sortactive = '全部'
      this.setlist()
      this.showCitySelect = true
    }
  },
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata;
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata;
    }
    if (this.cityId && this.cityId.length) {
      this.city_location = this.cityId;
    }
    this.localcity_data = JSON.parse(JSON.stringify(ChinaMap));
    // await this.fetchfujianData();
    this.addDataToTextList(); // 在组件挂载时添加数据到 text_List
    // this.autoTime();
  },
};
</script>
<style lang="scss" scoped>
.zgeMapBox {
  width: 950px;
  height: 723px !important;
  position: relative;
  margin-left: -17px;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: auto;
}

.mapBox {
  width: 90%;
  height: 90% !important;
  position: relative;
  // margin-left: -25px;

  .c1-title {
    // width: 188.5px;
    max-width: 220px;
    height: 40.5px;
    position: relative;
    line-height: 40.5px;
    font-size: 18px;
    text-align: center;
    font-style: italic;
    color: #fff;
    font-weight: 400;
    font-family: "bmzy";
    top: 0px;
    left: -20px;

    p {
      // padding-left: 30px;
    }
  }

  .map-title-img {
    width: 188.5px;
    height: 40.5px;
    left: 0;
    position: absolute;
  }

  .title_active {
    font-family: "bmzy";
    font-size: 16px;
    color: #fff;
    cursor: pointer;
    position: absolute;
    z-index: 102;
  }

  .active {
    width: 156px;
    height: 151px;
    background: url("@/assets/mapImg_Center/active.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    z-index: 103;
    font-family: "bmzy";
    font-size: 16px;
    color: #925b00;
    cursor: pointer;

    span {
      display: flex;
      width: 120px;
      height: 24px;
      font-family: "bmzy";
      position: absolute;
      top: 42px;
      left: 50%;
      justify-content: center;
      align-items: center;
      transform: translateX(-50%);
    }
  }

  .mapimg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0%;
    z-index: 2;
  }

  .textBox {
    min-width: 261px;
    height: 150px;
    position: absolute;
    // bottom: -2%;
    // right: 10%;
    background: url("@/assets/mapImg_Center/tooltip.png") no-repeat;
    background-size: 100% 100%;
    z-index: 1;
    padding: 10px 20px;
    box-sizing: border-box;
    color: #fff;
    font-size: 14px;
    line-height: 30px;
    text-align: left;
    z-index: 120;
    cursor: pointer;

    .title {
      color: #fff;
      font-size: 18px;
      width: 120px;
      font-family: "本墨字语";
      margin: -5px 0 0 -8px;
      // background: pink;
      text-align: center;
      // padding: 0 0 0 0px;
    }

    .textList {
      width: 100%;
      height: 92px;
      margin-top: 8px;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
    }

    .textList::-webkit-scrollbar {
      width: 0;
      /* 隐藏垂直滚动条 */
      height: 0;
      /* 隐藏水平滚动条 */
      scrollbar-width: none;
      /* Firefox */
      -ms-overflow-style: none;
      /* IE 和 Edge */
    }

    .textList_li:first-child {
      // margin-top: 14px;
    }

    .textList_li {
      font-size: 14px;
      color: #d0f7fe;
      display: flex;
      align-items: center;

      img {
        width: 20px;
        height: fit-content;
        margin-right: 8px;
      }

      .name {
        max-width: 140px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .colorText {
        color: #458ef7;
        margin-left: 8px;
      }
    }
  }
}

.city-select-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border: 1px solid #ccc;
  z-index: 1000;
}

.SpecialMap {
  position: absolute;
  top: 80%;
  transform: translateY(-50%);
  right: 40px;
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  // align-items: center;
  width: 120px;
  height: auto;
  color: #fff;
  z-index: 103;

  .SpecialMap_city {
    height: 40px;
  }

  .SpecialMap_name {
    font-family: "bmzy";
    font-size: 16px;
    line-height: 40px;
    color: #fff;
    cursor: pointer;
    transition: color 0.3s ease;

    /* 过渡效果：颜色变化在 0.3 秒内完成，动画效果为 ease */
    &:hover {
      color: #ffe700;
      /* 鼠标悬停时的颜色 */
    }
  }
}

.componentS {
  position: absolute;
  width: 1280px;
  /* height: 60vh; */
  background: #181a1b;
  border: 1px solid #3a3b3c;
  top: -2.2vh;
  left: 50%;
  transform: translateX(-50%);
  transition: all 1s ease;
  z-index: 501;

  .r_input {
    width: 400px;

    // 深度选择器穿透 scoped 样式
    .el-select {
      width: 100%;
      background: #212226;
      border-radius: 4px;
      border: 1px solid #3a3b3c;
      color: #ffffff; // 字体颜色
    }
  }
}

.componentS .componentTitle {
  width: calc(100% - 2px);
  height: 45px;
  background: #121212;
  display: flex;
  justify-content: space-between;
  font-family: "Hei";
  line-height: 45px;
}

.componentS .componentTitleName {
  font-size: 14px;
  color: #c0c0c0;
  margin-left: 30px;
}

.componentS .componentclose {
  width: 17px;
  margin-right: 30px;
  cursor: pointer;
}

.componentContents {
  position: relative;
  width: 92%;
  padding: 0 42px;
  box-sizing: border-box;

  &::after {
    content: "";
    position: absolute;
    height: 1px;
    width: 100%;
    left: 0;
    top: 62px;
    background: #3a3a3a;
  }

  .pre,
  .next {
    width: 6.5px;
    height: 11.5px;
    top: 28px;
    background: url(@/assets/temimg10/back.png) no-repeat;
    background-size: 100% 100%;
    position: absolute;
    cursor: pointer;
    z-index: 1;
  }

  .pre {
    left: 0;
    transform: rotate(180deg);
  }

  .next {
    right: 0;
  }
}

.componentClassAll {
  padding: 22px 24px 22px 24px;
  display: flex;
  align-items: center;
  column-gap: 56px;
  overflow-x: auto;
  position: relative;

  &::-webkit-scrollbar {
    height: 0px;
  }
}

.componentClassMenu {
  color: #818181;
  font-size: 14px;
  cursor: pointer;
  position: relative;
  transition: all 0.3s linear;
  width: fit-content;
  min-width: fit-content;

  &.active {
    font-size: 14px;
    color: #fff;
    font-family: "Hei";

    &::after {
      content: "";
      position: absolute;
      width: 0;
      height: 2px;
      background: #0089ff;
      bottom: -22.5px;
      left: 0;
      animation: zeroto 0.3s linear;
      animation-fill-mode: forwards;
    }
  }
}

.componentListAll {
  width: 100%;
  margin: 25px 0 0 0;
  display: flex;
  flex-wrap: wrap;
  height: 466px;
  column-gap: 11px;
  row-gap: 24px;
}

.componentList {
  width: 263px;
  animation: list 1s linear 1;
  animation-fill-mode: forwards;
  opacity: 0;
  cursor: pointer;
  height: fit-content;
  border: 1px solid transparent;
  transition: all 0.3s linear;

  &.active {
    border: 1px solid #3783f4;
    box-shadow: 0 0 15px #1963ea;
    border-radius: 5px;
  }
}

.componentList:hover {
  border: 1px solid #3783f4;
  box-shadow: 0 0 15px #1963ea;
  border-radius: 5px;
}

@keyframes list {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.componentPic {
  width: 100%;
  height: 148px;
  background: #1f1e1f;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.componentPic img {
  width: 100%;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  height: 100%;
  object-fit: contain;
}

.componentPicName {
  width: 100%;
  height: 40px;
  background: #2d2d33;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  line-height: 40px;
  color: #fff;
  font-size: 12px;
  text-indent: 1em;
  letter-spacing: 1px;
  font-family: "Hei";
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.map-dz {
  width: 884px;
  height: 344px;
  background: url(@/assets/mapImg_Center/map-dz.png) no-repeat;
  background-size: 100% 100%;
  position: absolute;
  bottom: -205px;
}
.map-bg {
  width: 1389.5px;
  height: 958px;
  background: url(@/assets/mapImg_Center/map-bg.png) no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: -64px;
}
.map-ani {
  width: 120px;
  object-fit: fill;
  opacity: 1;
  transform: none;
  width: 900px;
  position: absolute;
  z-index: 1;
  pointer-events: none;
}
</style>
